import { render } from "./ProcessItemSummary.vue?vue&type=template&id=3faccc31&scoped=true&ts=true"
import script from "./ProcessItemSummary.vue?vue&type=script&lang=ts"
export * from "./ProcessItemSummary.vue?vue&type=script&lang=ts"

import "./ProcessItemSummary.vue?vue&type=style&index=0&id=3faccc31&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3faccc31"]])

export default __exports__